import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Avatar, Grid } from "@material-ui/core";

import {
  getUsersFromState,
  getAppRolesFromState,
  getSummarizedDataStatesFromState,
} from "app/app.selectors";

import {
  updateUser,
  userAccessOnLoad,
  userAccessOnUnload,
} from "features/planner/planner.actions";

import { APP_ACTIONS } from "app/app.constants";
import { createUserAppRoles } from "app/app.actions";
import CrudBasePage from "app/components/CrudBasePage";
import { getAvatar, getInitials } from "utils/app.util";
import SortableListRowIcon from "app/components/SortableList/SortableListRowIcon";
import AppRolesSelectField from "features/planner/settings/access/components/AppRolesSelectField";

class SettingsUserAccessContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad } = this.props;
    dispatchOnLoad();
  }

  columns = [
    {
      xs: 4,
      title: "Name",
      getSortProperty: user => user.get("displayName"),
    },
    {
      xs: true,
      component: Grid,
      title: "Access Rights",
      getValue: user => {
        return (
          <AppRolesSelectField
            userId={user.get("id")}
            value={user.get("appRoles")}
            appRoles={this.props.appRoles}
            onChange={appRoles =>
              this.props.dispatchCreateUserAppRoles(user.get("id"), appRoles)
            }
          />
        );
      },
    },
  ];

  renderIcon = user => (
    <SortableListRowIcon transparent>
      <Avatar src={getAvatar(user.get("avatar"))}>
        {!user.get("avatar") && getInitials(user.get("displayName"))}
      </Avatar>
    </SortableListRowIcon>
  );

  render() {
    const { Icon, breadcrumb, users, dataState } = this.props;

    return (
      <CrudBasePage
        Icon={Icon}
        title={breadcrumb}
        items={users}
        displaySearchField
        dataState={dataState}
        SortableListProps={{
          Icon: null,
          actions: [],
          columns: this.columns,
          renderIcon: this.renderIcon,
          getKey: item => item.get("id"),
        }}
      />
    );
  }
}

export default compose(
  connect(
    state => ({
      users: getUsersFromState(state),
      appRoles: getAppRolesFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        APP_ACTIONS.GET_USERS,
        APP_ACTIONS.CREATE_USER_APP_ROLES,
      ),
    }),
    {
      dispatchUpdateUser: updateUser,
      dispatchOnLoad: userAccessOnLoad,
      dispatchOnUnload: userAccessOnUnload,
      dispatchCreateUserAppRoles: createUserAppRoles,
    },
  ),
)(SettingsUserAccessContainer);
